import type { ChangeEvent } from 'react'
import React from 'react'
import type { SystemProps } from '@xstyled/styled-components'
import { StyledTextArea } from './Transcription.styles'
import { TranscriptionPreview } from './TranscriptionPreview'
import { getDirectionForLanguage } from './directionForLanguage'

export interface TranscriptionProps {
  dataTestId?: string
  language: string
  isDisabled?: boolean
  value: string | null
  rows?: number
  maxRows?: number
  minRows?: number
  onChange?: (value: string) => void
  isReadonly?: boolean
  size?: 'lg' | 'md'
  border?: 'hover' | 'always' | 'none'
  fullWidth?: boolean
  dynamicHeight?: boolean
  placeholder?: string
  h?: SystemProps['h']
  onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void
}

export function Transcription(props: TranscriptionProps): JSX.Element {
  const directionForLanguage = getDirectionForLanguage(props.language)
  const [fontSize, lineHeight] =
    props.size === 'lg' ? [18, '156%'] : [16, '140%']
  const borderType = props.border ?? 'hover'

  if (props.isReadonly) {
    return (
      <TranscriptionPreview
        testId={props.dataTestId}
        value={props.value}
        rows={props.rows}
        language={props.language}
        h={props.h}
        dynamicHeight={props.dynamicHeight}
        size={props.size}
        background={borderType}
      />
    )
  }

  return (
    <StyledTextArea
      testId={props.dataTestId}
      resize='none'
      placeholder={props.placeholder}
      value={props.value}
      rows={props.rows}
      maxRows={props.maxRows}
      minRows={props.minRows}
      onChange={(e: ChangeEvent<HTMLTextAreaElement>) =>
        props.onChange?.(e.target.value)
      }
      onBlur={props.onBlur}
      dir={directionForLanguage.direction}
      textAlign={directionForLanguage.alignment}
      disabled={props.isDisabled}
      fontSize={fontSize}
      lineHeight={lineHeight}
      fontWeight={400}
      color='grey.d2'
      borderType={borderType}
      fullWidth={props.fullWidth}
      dynamicHeight={props.dynamicHeight}
      h={props.h}
    />
  )
}
